import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { TrendingUp } from "lucide-react";
import api from "@/lib/api";
import { useLang } from "@/lib/i18n";

// "Most checked this week" — real, de-duplicated counts from the server.
// Hidden completely until there is enough data (no made-up popularity).
export const Trending = () => {
  const { t } = useLang();
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  useEffect(() => {
    let alive = true;
    api.get("/trending").then((r) => { if (alive) setItems(r.data.enough_data ? r.data.items : []); }).catch(() => {});
    return () => { alive = false; };
  }, []);
  if (!items.length) return null;
  return (
    <section data-testid="trending" className="vlx-container pt-10">
      <p className="flex items-center gap-2 font-display text-lg font-bold text-brand-navy">
        <TrendingUp className="h-5 w-5 text-brand" /> {t("trending_title")}
      </p>
      <div className="-mx-1 mt-3 flex gap-2.5 overflow-x-auto px-1 pb-2">
        {items.map((it) => (
          <button key={it.model_id} data-testid={`trending-${it.model_id}`}
            onClick={() => navigate(`/valuate?category=${it.category}&model=${encodeURIComponent(it.label)}`)}
            className="shrink-0 rounded-2xl border border-slate-200 bg-white px-4 py-3 text-left shadow-sm hover:border-brand">
            <p className="font-display text-sm font-bold text-brand-navy">{it.label}</p>
            <p className="text-xs text-slate-500">{t("trending_checks", { n: it.checks })}</p>
          </button>
        ))}
      </div>
    </section>
  );
};
